import { render } from "./TreeViewEditorCmp.vue?vue&type=template&id=0c0bd15a"
import script from "./TreeViewEditorCmp.vue?vue&type=script&lang=js"
export * from "./TreeViewEditorCmp.vue?vue&type=script&lang=js"

import "./TreeViewEditorCmp.vue?vue&type=style&index=0&id=0c0bd15a&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__